// Custom Peterbilt-style Semi-Truck Icon - Mean looking big rig
export const SemiTruck = ({ className = "w-6 h-6", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    {/* Long hood Peterbilt style cab */}
    <path d="M1 14h4V9.5L7 8h4l1 1.5V14h11v2H1v-2z" />
    {/* Hood/Engine - Long nose style */}
    <path d="M5 14V9.5L7 8h4l1 1.5V14" />
    {/* Sleeper cab back */}
    <rect x="12" y="8" width="4" height="6" rx="0.5" />
    {/* Grille - vertical slats (Peterbilt signature) */}
    <line x1="6" y1="9" x2="6" y2="13" />
    <line x1="7.5" y1="8.5" x2="7.5" y2="13" />
    <line x1="9" y1="8.5" x2="9" y2="13" />
    <line x1="10.5" y1="9" x2="10.5" y2="13" />
    {/* Exhaust stacks */}
    <line x1="11.5" y1="8" x2="11.5" y2="5" />
    <line x1="16.5" y1="8" x2="16.5" y2="5" />
    {/* Trailer connection */}
    <path d="M16 12h2" />
    {/* Trailer */}
    <rect x="18" y="10" width="5" height="6" rx="0.5" />
    {/* Front wheel - big */}
    <circle cx="6" cy="17" r="2" strokeWidth="2" />
    {/* Drive wheels - dual */}
    <circle cx="14" cy="17" r="2" strokeWidth="2" />
    {/* Trailer wheels */}
    <circle cx="21" cy="17" r="2" strokeWidth="2" />
    {/* Bumper */}
    <path d="M1 14h4" strokeWidth="2" />
    {/* Headlight */}
    <circle cx="5" cy="11" r="0.5" fill="currentColor" />
  </svg>
);

export default SemiTruck;
